var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdleMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11111 24.8889H26.4444C27.3036 24.8889 28 25.5853 28 26.4444C28 27.3036 27.3036 28 26.4444 28H1.55556C0.696446 28 0 27.3036 0 26.4444V1.55556C0 0.696446 0.696446 0 1.55556 0C2.41467 0 3.11111 0.696446 3.11111 1.55556V24.8889Z",
    fill: "#4AD991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.91256 18.175C8.32498 18.8017 7.34057 18.8335 6.71382 18.2459C6.08707 17.6583 6.05531 16.6739 6.64289 16.0472L12.4762 9.82494C13.0445 9.21879 13.9888 9.16623 14.6208 9.70555L19.2248 13.6343L25.2235 6.03606C25.7558 5.36176 26.734 5.24668 27.4083 5.77903C28.0826 6.31137 28.1977 7.28955 27.6653 7.96385L20.6653 16.8305C20.1186 17.5231 19.1059 17.6227 18.4347 17.0499L13.7306 13.0358L8.91256 18.175Z",
    fill: "#4AD991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleMachines);
export default __webpack_public_path__ + "static/media/Idle Machines.5f3b903c26dfd5ccb28c67e741dfad29.svg";
export { ForwardRef as ReactComponent };